import React, { Component } from "react";
import MainLayout from '../../mainLayout';

//Connect Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//Service import 
import service from '../../services'

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

// Images import
import selectArrow from "../../assets/images/select-arrow.svg";
import plusIcon from "../../assets/images/plusIcon.svg";
import background from "../../assets/images/background.jpg";
import Loader from "../loader";
import CheckBox from "../CheckBox";

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import TextEditor from "../TextEditor";
import ErrorPopUp from "../errorPopUp";

//moment import
import moment from "moment-timezone";
import commonImage from "../../commonImage";

let sub;
const mapStateToProps = state => ({
  getPartnerDetails: state.getPartnerDetails,
  getLoginRole: state.getLoginRole
})

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActCreators, dispatch)
};

class profilePartnerView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      contactFullName: '',
      lastName: '',
      getPerticularPartner: '',
      instituteAssociate: false,
      file: null,
      id: '',
      partnerSubTitle: '',
      selectedDropdown: '',
      imagePreloader: false,
      imagePreloader1: false,
      loaderFlag: false,
      // partnerPageDescription: EditorState.createEmpty(),
      // ShortDescription :EditorState.createEmpty(),
      // satellitePageDescription :EditorState.createEmpty(),
      // landingPageShortDescription :EditorState.createEmpty(),
      shortDescLength:0,
      lengthErr:''
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount = async () => {
    // this.apiserve.connect();     
    this.getPartner();
    this.getPartnerID();
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "getUser":
          this.setState({
            getPerticularPartner: response.data
          }, () => {
            

           
            if(response.data.satellitePageDescription){
              const blocksFromHtml = htmlToDraft(response.data.satellitePageDescription ? response.data.satellitePageDescription : "");
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
              const editorState = EditorState.createWithContent(contentState);
              this.setState({
                editorState:editorState
              })
            }
            if(response.data.landingPageShortDescription){
            const blocksFromHtmlShort = htmlToDraft(response.data.landingPageShortDescription ? response.data.landingPageShortDescription : "");
            const { contentBlocks, entityMap } = blocksFromHtmlShort;
            const contentStateShort = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorStateShort = EditorState.createWithContent(contentStateShort);
            this.setState({
              shortDesc:editorStateShort
            })
            }
            this.setState({
              satelliteScreenThumbnail: response.data.satelliteScreenThumbnail,
              satelliteLogo:response.data.satelliteLogo,
              satelliteScreenName: response.data.satelliteScreenName,
              contactFullName: response.data.contactFullName,
              city: response.data.city,
              state: response.data.state,
              email: response.data.email,
              id: response.data._id,
              // editorState: editorState,
              // shortDesc:editorStateShort
            })
          })
          break;
        case "FestivalVillage|SatelliteScreen|edit":
          if (response.error) {
            this.apiserve.error(response.data.error ? response.data.error : response.data)
          } else {
            this.apiserve.success('Partner user updated successful.')
            this.getPartner()
            this.getPartnerID();
          }
          break;
          case "FestivalVillage|SatelliteScreen|getSatelliteById":
            this.setState({
                updateDate: response.data.updatedAt,
                updatedBy:response.data.addedBy
              })
        break;
      }
    })
  }

  componentWillUnmount = () => {
    sub.unsubscribe();
  }

  getPartner = () => {
    const { getLoginRole } = this.props
    this.apiserve.sendevent("getUser", {
      id: getLoginRole.user?._id
    });
  }

  getPartnerID = () => {
    const {getLoginRole} = this.props
    this.apiserve.sendevent("FestivalVillage|SatelliteScreen|getSatelliteById", {
       id:getLoginRole.user._id
    });
}

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  onInputChangeDropDown = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      selectedDropdown: e.target.value
    });
  }

  submitFn = (e) => {
    const { getPartnerDetails } = this.props
    e.preventDefault();


    if (this.validator.allValid() && this.state.shortDescLength <= 40) {
      const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
      const markup = draftToHtml(name);

      const name1 = this.state.shortDesc ? convertToRaw(this.state.shortDesc.getCurrentContent()) : ''
      const markupShort = draftToHtml(name1);

      
      let data = {
        id: this.state.id,
        satellitePageDescription: markup,
        satelliteScreenThumbnail: this.state.satelliteScreenThumbnail ? this.state.satelliteScreenThumbnail : '',
        satelliteLogo:this.state.satelliteLogo ? this.state.satelliteLogo : '',
        satelliteScreenName: this.state.satelliteScreenName,
        email: this.state.email,
        contactFullName: this.state.contactFullName,
        landingPageShortDescription:markupShort,
        // city: this.state.city,
        // state: this.state.state
      }
      this.apiserve.sendevent("FestivalVillage|SatelliteScreen|edit", data);
    } else {
      // this.validator.showMessages();
      // this.forceUpdate();
      this.setState({
        messageModal: true,
      })
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  clearFn = () => {
    this.setState({
      satelliteScreenThumbnail: '',
      satelliteLogo: '',
      satelliteScreenName: '',
      contactFullName: '',
      city: '',
      state: ''
    });
  };

  onChangeFileSatelliteLogo(e) {
    e.stopPropagation()
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file,
      }, () => {
        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file smaller than 2 MB'
          })
          return false;
        }
        if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
            setTimeout(() => {
                this.imageUploadSatelliteLogo(file,event.target.result);
              },0)
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file for PNG,JPG or JPEG'
          })
        }
      });
    }
  }

  imageUploadSatelliteLogo = (file, img) => {
    this.setState({ imagePreloader1: true })

    var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
        this.setState({
          satelliteLogo: value,
          imagePreloader1: false
        });
      });
  };

  onChangeFile(e) {
    e.stopPropagation()
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file,
      }, () => {
        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file smaller than 2 MB'
          })
          return false;
        }
        if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
            setTimeout(() => {
                this.imageUpload(file,event.target.result);
              },0)
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file for PNG,JPG or JPEG'
          })
        }
      });
    }
  }

  imageUpload = (file, img) => {
    this.setState({ imagePreloader: true })

    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
        this.setState({
          satelliteScreenThumbnail: value,
          imagePreloader: false
        });
      });
  };

  onChangeFileVenueImage(e) {
    e.stopPropagation()
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file,
      }, () =>
        setTimeout(() => {
          this.imageUploadVenue(file,event.target.result);
        }, 0))
    }
  }

  imageUploadVenue = (file,img) => {
    this.setState({ imagePreloader1: true })

    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
        this.setState({
          image: value,
          imagePreloader1: false
        });
      });
  };

  handleUncheck = (e) => {
    const { name, value, checked } = e.target;
    this.setState({
      [name]: checked
    })
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState
    });
  };

  onEditorStateChangeShortDesc = (shortDesc) => {
    const ShortDesc = this.state.shortDesc ? convertToRaw(this.state.shortDesc.getCurrentContent()) : ''

    let Blocks = ShortDesc ? ShortDesc.blocks : [];
    let shortDescLength = 0

    if(Blocks.length === 0) { 

    } else if(Blocks.length === 1) {
      shortDescLength = Object.keys(ShortDesc?.blocks[0]?.text?.split(' ').filter(_ => _ !== '')).length 
    } else {
      let localLength = 0;

      Blocks.forEach(block => {
        localLength = localLength + Object.keys(block.text?.split(' ').filter(_ => _ !== '')).length 
      });

      shortDescLength = localLength;
    }

    if(shortDescLength <= 40 ){
      this.setState({
        shortDesc,
        shortDescLength:shortDescLength,
        lengthErr:''
      });
    }else {
    this.setState({
      shortDesc,
      shortDescLength:shortDescLength,
      lengthErr:'Landing Page Short Description field has limit of 40 words.'
    })
    }
    
  };

  validateModel = () => {
    this.setState({
        errorPopup: false,
    });
  };

deleteImagePopup = () => {
    this.setState({
        satelliteScreenThumbnail:'',
        satelliteLogo: '',
        deleteImagePopup:false,
    })
}

deleteImage(){
    this.setState({
        deleteImagePopup:true,
    })
}

getHTMLValue = (value) => {
  const convertedValue = value ? convertToRaw(value.getCurrentContent()) : ''
  return convertedValue ? convertedValue.blocks[0].text : ''
}


  render() {

    // this.validator.purgeFields();
    const { getPerticularPartner } = this.state;
    const { getLoginRole } = this.props;
    return (
      <React.Fragment>
        <div className={`right_side_wrapper partnerView_wrapper ${getLoginRole.user?.role === "satellite" ? "partner_view_wrapper" : ""}`}>
          <div className="dashboard_header profile_header">
            <div className="searchBlock">
              <span>{getPerticularPartner && getPerticularPartner.satelliteScreenName}</span>
            </div>
          </div>
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
              <p></p>
              <p className="update_date">
                Last Update: {moment(this.state.updateDate).tz("US/Mountain").format('h')}:{moment(this.state.updateDate).tz("US/Mountain").format('mm')} {moment(this.state.updateDate).tz("US/Mountain").format('A')}{' '}
              MT- {moment.tz(this.state.updateDate, "US/Mountain").format('MM/DD/YYYY')}{' '}Last Updated By: {this.state.updatedBy && this.state.updatedBy.fname} {this.state.updatedBy && this.state.updatedBy.lname}
            </p>
          </div>
          <div className="profilePartnerView_block">
            <form>
              <div className="details">
              <div className="partnerLogo">
                  <label>Partner Logo</label>
                  <div className='image_pre_loader'>
                    <input id="myInput"
                      type="file"
                      ref={(ref) => this.upload1 = ref}
                      style={{ display: 'none' }}
                      onChange={this.onChangeFileSatelliteLogo.bind(this)}
                      accept=".png, .jpg, .jpeg"
                    />
                    {this.state.imagePreloader1 ?
                      <Loader />
                      :
                      <img src={this.state.satelliteLogo ?
                        this.apiserve.imageUrl + this.state.satelliteLogo
                        : background} />
                    }
                    <a onClick={() => { this.upload1.click() }}><img src={plusIcon} /></a>
                  </div>
                </div>
                <div className="partnerLogo">
                  <label>Partner Thumbnail</label>
                  <div className='image_pre_loader'>
                    <input id="myInput"
                      type="file"
                      ref={(ref) => this.upload = ref}
                      style={{ display: 'none' }}
                      onChange={this.onChangeFile.bind(this)}
                      accept=".png, .jpg, .jpeg"
                    />
                    {this.state.imagePreloader ?
                      <Loader />
                      :
                      <img src={this.state.satelliteScreenThumbnail ?
                        this.apiserve.imageUrl + this.state.satelliteScreenThumbnail
                        : background} />
                    }
                    <a onClick={() => { this.upload.click() }}><img src={plusIcon} /></a>
                  </div>
                </div>
                <div className="form_group">
                  <label>Partner Name</label>
                  <div className="form_group_input">
                    <input type="text" name="satelliteScreenName" id="satelliteScreenName"
                      value={this.state.satelliteScreenName}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                    <span className="error">{this.validator.message('Partner Name', this.state.satelliteScreenName, 'required')}</span>
                  </div>
                </div>
                <div className="form_group">
                  <label>Contact Email</label>

                  <div className="form_group_input">
                    <input
                      type="email"
                      disabled
                      name="email"
                      id="email"
                      maxLength={255}
                      value={this.state.email}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="form_group">
                  <label>Contact Full Name</label>

                  <div className="form_group_input">
                    <input
                      type="text"
                      name="contactFullName"
                      id="contactFullName"
                      value={this.state.contactFullName}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                    <span className="error">{this.validator.message('contact FullName', this.state.contactFullName, 'required')}</span>
                  </div>
                </div>
                <div className="form_group">
                  <label>Partner Description</label>
                  <div className="form_group_input editor_400">
                    <TextEditor
                      name="editorState"
                      editorState={this.state.editorState}
                      value={this.state.editorState}
                      onEditorStateChange={(e) =>
                        this.onEditorStateChange(e)}
                    />
                    <span className="error">{this.validator.message('Partner Description', this.getHTMLValue(this.state.editorState), 'required')}</span>

                  </div>
                </div>

                <div className="form_group">
                  <label>Landing Page Short Description</label>
                  <div className="form_group_input editor_400">
                    <TextEditor
                      name="shortDesc"
                      editorState={this.state.shortDesc}
                      value={this.state.shortDesc}
                      onEditorStateChange={(e) =>
                        this.onEditorStateChangeShortDesc(e)}
                    />
                    <span className="error">{this.validator.message('Landing Page Short Description', this.getHTMLValue(this.state.shortDesc) , 'required')}</span>
                    {/* <span className="error">{this.state?.shortDesc?.length > 0 ? '': 'Landing Page Short Description field is required'}</span> */}
                    <span className="error">{this.state.shortDescLength > 40 ? this.state.lengthErr :''}</span>
                  </div>
                </div>
                {/* <div className="form_group">
                  <label>City</label>
                  <div className="form_group_input">
                    <input
                      type="text"
                      name="city"
                      id="city"
                      value={this.state.city}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                    <span className="error">{this.validator.message('city', this.state.city, 'required')}</span>
                  </div>
                </div>
                <div className="form_group">
                  <label>State</label>
                  <div className="form_group_input">
                    <input
                      type="text"
                      name="state"
                      id="state"
                      value={this.state.state}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                    <span className="error">{this.validator.message('state', this.state.state, 'required')}</span>
                  </div>
                </div> */}

              </div>
              <div className="btn_wrapper">
                <button className="grayBTN"
                  type="button"
                  onClick={() => this.clearFn()}
                >Clear</button>
                <button className="orangeBTN"
                  type="button"
                  disabled={this.state.imagePreloader ? true : false}
                  onClick={(e) => this.submitFn(e)}
                >Submit</button>
              </div>
            </form>
          </div>
        </div>

        {this.state.errorPopup ? (
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.validateModel}
                    />
                ) : (
                        ""
                    )}
      </React.Fragment>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(profilePartnerView)